import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';
import { ComponentClass } from 'react';

import './mutators';
import './orchestrators';

export { getMoveToMenuProps } from './components/getMoveToMenuProps';
export { default as MoveToFolderType } from './store/schema/MoveToFolderType';
export { default as MoveToFoldersType } from './store/schema/MoveToFoldersType';
export { default as MoveToMenuItem } from './store/schema/MoveToMenuItem';
export { default as getFolderNameToCountMap } from './helpers/getFolderNameToCountMap';
export { MoveToActionSource } from './datapoints';
export { default as MoveToMailboxContext } from './store/schema/MoveToMailboxContext';

export {
    default as onFolderClickedInMoveToControlAction,
} from './actions/onFolderClickedInMoveToControl';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MoveTo", webpackPrefetch: true */ './lazyIndex')
);

export const lazyGetFoldersForMoveTo = new LazyImport(lazyModule, m => m.getFoldersForMoveTo);

// Delayed Loaded Components
export var MoveToFolder = createLazyComponent(lazyModule, m => m.MoveToFolder);
export { ComponentClass };
